import { Component, OnInit } from '@angular/core';
import { Option } from 'src/app/models/survey/options';
import { Message } from '../../../../../../../models/message';
import { OptionsService } from '../../../../../../../services/survey/options.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-svoption-list',
  templateUrl: './svoption-list.component.html',
  styleUrls: ['./svoption-list.component.scss']
})
export class SvoptionListComponent implements OnInit {

  svoption: Option = null;
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  idquestionSelected: string = null;

  constructor(
    private optionS: OptionsService,
    private activedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idquestionSelected = params['idquestion'];
    this.get4OptionAdm(params['idquestion']);
  }

  get4OptionAdm(id: string) {
    this.optionS.get4question(id).subscribe(
      res => { this.svoption = res['data']; },
      err => { this.msg = err; }
    );
  }

  remove(id: string) {
    this.optionS.delete(id).subscribe(
      res => {
        this.msg.message = res['message'];
        this.msg.status = res['status'];
        this.hiddenMsg = false;
        this.get4OptionAdm(this.idquestionSelected);
      },
      err => {
        this.msg.message = err["error"].message;
        this.msg.status = err["error"].status;
      }
    );
  }


}

